import { useBreakpoint } from '../../../hooks';
import { CatHeading } from '@blocks-react/components/Heading';
import { PAGE_BREAKPOINTS } from '../../../constants/commonConstants';
import { ProductCardThumbnail, ProductComparisonGrid } from '../../product';
import { ServiceRecommendationSubTotal } from '../service-recommendation-subtotal';
import { priceAvailabilityProps, priceCardTranslationProps } from '../types';
import { ServiceRecommendationPartCardFooterWrapper } from './service-recommendation-part-card-footer-wrapper';
import { ServiceRecommendationPartQuantity } from './service-recommendation-part-quantity';
import { ServiceRecommendationPriceWrapper } from './service-recommendation-price-wrapper';
import cx from 'classnames';
import styles from '../serviceRecommendation.module.scss';

type PartsContainerProps = {
  data: priceAvailabilityProps;
  translations: priceCardTranslationProps;
  subTotal: string;
};

export const ServiceRecommendationPartsContainer = ({
  data,
  translations,
  subTotal
}: PartsContainerProps) => {
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
  return (
    <>
      <CatHeading level="h5">{translations.parts}</CatHeading>

      <ProductComparisonGrid
        classname={`${styles['parts-container']} column-gap-4`}
      >
        {data?.items.map((part: any) => {
          return (
            <div
              className={cx('d-flex p-2', {
                'flex-column': isMD,
                'p-3 mb-2': !isMD
              })}
              key={part.id}
            >
              <div
                className={cx('d-flex justify-content-center', {
                  'mr-2 align-self-start': !isMD,
                  [styles['parts-container_flex_none']]: !isMD,
                  'mb-2': isMD
                })}
              >
                <ProductCardThumbnail
                  imgProps={{
                    alt: part?.partNumber,
                    src: part?.partDetails?.imageURL,
                    width: isMD ? 160 : 72,
                    height: isMD ? 160 : 72
                  }}
                />
              </div>
              <div
                className={cx('flex-grow-1', {
                  'd-flex justify-content-between flex-column': isMD
                })}
              >
                <CatHeading
                  variant="label"
                  className={cx(styles['parts-container_ellipsis'])}
                >
                  {part?.partNumber}: {part?.partDetails?.partsTitle}
                </CatHeading>
                <ServiceRecommendationPartCardFooterWrapper>
                  <ServiceRecommendationPriceWrapper
                    totalprice={part?.priceDetails?.totalPrice}
                    price={part?.priceDetails?.unitPrice}
                    currency={data?.currency}
                    translation={translations.eachItem}
                  />
                  <ServiceRecommendationPartQuantity
                    title={translations.quantity}
                    quantity={part.quantity}
                  />
                </ServiceRecommendationPartCardFooterWrapper>
              </div>
            </div>
          );
        })}
      </ProductComparisonGrid>
      <ServiceRecommendationSubTotal
        translations={translations}
        subtotal={subTotal}
        totalItems={data?.items?.length}
      />
    </>
  );
};
